export const myData = {
    fullName: "Jakub Helizanowicz",
    description: "I’m a passionate Frontend Developer, like to work with React, currently working as a postman, looking for new job opportunities",
    email: "jakubhelizanowicz@gmail.com",

    currentSkills: [
        "Semantic & accessible HTML",
        "Responsive Web Design",
        "Teamwork",
        "Markdown",
        "Immutability",
        "CSS BEM convention",
        "CSS Grid",
        "CSS Flexbox",
        "React Router",
        "Redux-Saga",
        "Redux (Toolkit)",
        "React Hooks",
        "Error handling",
        "Working with API (fetch, axios)",
        "JavaScript ES6+",
        "Promises, Async/Await",
        "GitHub Pull Requests & Review",
        "Trello",
        "Scrum",
        "NPM",
        "React",
        "Git",
    ],
    skillsToLearn: [
        "React Context",
        "Node.js",
        "Cypress",
        "Unit testing",
        "TypeScript",
        "JS classes",
    ],
    githubLink: "https://github.com/HelkaPL",
    linkedInLink: "https://www.linkedin.com/in/jakub-helizanowicz-0352abba/",
    facebookLink: "https://www.facebook.com/HelkaPL/",
    instagramLink: "https://www.instagram.com/helka223/",

};